import React, { useState } from 'react';

const ReadMore = ({ children, maxLength = 350 }) => {
    const [isTruncated, setIsTruncated] = useState(true);
    const text = children;

    const toggleTruncate = () => {
        setIsTruncated(!isTruncated);
    };

    if (!text || text.length <= maxLength) {
        return <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{text}</p>;
    }

    return (
        <div>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                {isTruncated ? `${text.slice(0, maxLength)}...` : text}
            </p>
            <button onClick={toggleTruncate} className="text-primary-600 dark:text-primary-400 font-semibold hover:underline mt-2">
                {isTruncated ? 'Read more' : 'Read less'}
            </button>
        </div>
    );
};

export default ReadMore; 